import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { BookSetupContainer } from '../components/book-creation/BookSetup/BookSetupContainer';
import { Config } from '../services/Config';
import { OnboardingProvider } from '../services/routing/OnboardingProvider';
import { SubscriptionProvider } from '../services/Subscription/SubscriptionProvider';
import { useTrackWithPendo } from '../utils/useTrackWithPendo';

export const Route = createFileRoute('/book-setup')({
  staticData: {
    secure: true,
  },
  component: BookSetupRoute,
});

function BookSetupRoute() {
  useTrackWithPendo();

  function handleCancelClick() {
    window.location.href = Config.APPLICATION_RECKON_LOGIN_URL;
  }

  return (
    <OnboardingProvider>
      <SubscriptionProvider>
        <BookSetupContainer onCancelClick={handleCancelClick} />
      </SubscriptionProvider>
    </OnboardingProvider>
  );
}
